"use client";

import { useAuth } from "@clerk/nextjs";
import { ConvexReactClient } from "convex/react";
import { ConvexProviderWithClerk } from "convex/react-clerk";
import { ConvexQueryCacheProvider } from "convex-helpers/react/cache/provider";
import type { ReactNode } from "react";
import { WorkspaceProvider } from "./WorkspaceProvider";

const convexUrl = process.env.NEXT_PUBLIC_CONVEX_URL;
const convex = convexUrl ? new ConvexReactClient(convexUrl) : null;

export default function ConvexClientProvider({
  children,
}: {
  children: ReactNode;
}) {
  if (!convex) {
    // No Convex URL configured: run REST-only (workspace + billing via
    // lib/llamox). Real-time subscriptions are unavailable until
    // NEXT_PUBLIC_CONVEX_URL is set.
    return <WorkspaceProvider hasConvex={false}>{children}</WorkspaceProvider>;
  }

  return (
    <ConvexProviderWithClerk client={convex} useAuth={useAuth}>
      <ConvexQueryCacheProvider>
        <WorkspaceProvider hasConvex>{children}</WorkspaceProvider>
      </ConvexQueryCacheProvider>
    </ConvexProviderWithClerk>
  );
}
